module.exports = __webpack_public_path__ + "al.svg?790143d0876fcbb1a90497a95b923078";